import { Component, Injector, Input, Optional } from '@angular/core';

import { PakbonService } from 'src/app/core/service/pakbon.service';
import { Pakbon } from 'src/app/core/dto/pakbon';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Project } from 'src/app/core/dto/project';

@Component({
    selector: 'c-i-j-borculo-pakbon-collection',
    templateUrl: './pakbon-collection.component.html'/*,
    styleUrls: ['./pakbon-collection.component.css'] */
})
export class PakbonCollectionComponent extends PagedCollectionComponent<Pakbon> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Pakbon>([
		{ colDef: 'pakbonnummer', prop: x => x.pakbonnummer, searchable: SearchableType.String },
		{ colDef: 'datumPakbon', prop: x => x.datumPakbon, searchable: SearchableType.Date },
        { colDef: 'factuur', prop: x => x.factuur, searchable: SearchableType.String },
        { colDef: 'project', prop: x => x.project.code, searchable: SearchableType.String },		
        { colDef: 'klant', prop: x => x.project.relatie.naam1, searchable: SearchableType.String },		
        { colDef: 'verzendtarief', prop: x => x.verzendtarief.omschrijving, searchable: SearchableType.String },				
		{ colDef: 'verzendbedrag', prop: x => x.verzendbedrag, searchable: SearchableType.Number },
		{ colDef: 'opmerking', prop: x => x.opmerking, searchable: SearchableType.String }        
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: PakbonService, @Optional() protected filter: Filter<Pakbon>, injector: Injector) {
        super('/pakbon/pakbon', injector, Pakbon);

        this.initInput('project', this.filterBuilder.equal(x => x.project.id));

        // Sorteren op DatumMail ASC
        this.orderBy = [-2];

        this.filter.onGetChipLabel(x => x.pakbonnummer, () => 'Pakbonnummer');
        this.filter.onGetChipLabel(x => x.datumPakbon, () => 'Datum pakbon');
        this.filter.onGetChipLabel(x => x.factuur, () => 'Factuur');
        this.filter.onGetChipLabel(x => x.project.code, () => 'Project');
        this.filter.onGetChipLabel(x => x.project.relatie.naam1, () => 'Klant');
        this.filter.onGetChipLabel(x => x.verzendtarief.omschrijving, () => 'Verzendtarief');
        this.filter.onGetChipLabel(x => x.verzendbedrag, () => 'Verzendbedrag');
        this.filter.onGetChipLabel(x => x.opmerking, () => 'Opmerking');
    
    }

    private _project: Project;

    @Input() set project(val: Project) {
        this.handleInput('project', val.id);
        this._project = val;
    }
        
    canDelete() {
        return false;
    }

}